(function ($) {
  // noConflict モード: ここから下では $ で jQuery を使用
  class Top {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      if (document.querySelector('.js-topWorks')) {
        new TopWorks('.js-topWorks');
      }
      if (document.querySelector('.js-topInterview')) {
        new TopInterview('.js-topInterview');
      }
    }
  }
  
  class Accordion {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.' + this.el).click(function() {
         $(this).next().slideToggle(Number($('html').data('transition')));
         $(this).toggleClass('is-active');
      })
    }
  }
    // 参考サイト
  // https://hacknote.jp/archives/15289/
  
  let cookie = {
  	/**
  	 * 取得
  	 * @param {string} cookieName 取得するCookieの名前
  	 */
  	get : function(cookieName) {
  		if (!navigator.cookieEnabled) return false;
  
  		var getCookieAllData  = document.cookie,
  		    getCookieAllDatas = getCookieAllData.split(';'),
  		    getCookieDatas    = {},
  		    cookieKeyValue    = [],
  		    cookieKey         = '',
  		    cookieValue       = '';
  
  		var hashLength = function(arr) {
  			var result = 0, key = false;
  
  			if (typeof arr !== 'object') return false;
  
  			for (key in arr) result++;
  
  			return result;
  		};
  
  		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
  			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
  				cookieKeyValue = getCookieAllDatas[i].split('=');
  				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
  				cookieValue    = '';
  
  				if (cookieKeyValue[1]) {
  					cookieValue = decodeURIComponent(cookieKeyValue[1]);
  				}
  
  				getCookieDatas[cookieKey] = cookieValue;
  			}
  		}
  
  		if (hashLength(getCookieDatas) > 0) {
  			if (cookieName && cookieName in getCookieDatas) {
  				return getCookieDatas[cookieName];
  			} else {
  				return getCookieDatas;
  			}
  		} else {
  			return '';
  		}
  	},
  
  	/**
  	 * 設定
  	 * @param {string} cookieName 設定するCookieの名前
  	 * @param {string} value 設定する値
  	 * @param {string} domain 有効ドメイン
  	 * @param {string} path 有効パス
  	 * @param {string} expires 有効期限
  	 * @param {boolean} secure セキュアとするか
  	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	set : function(cookieName, value, domain, path, expires, secure) {
  		if (!navigator.cookieEnabled || !cookieName || !value) return false;
  
  		var date, dt, ts, ts_after;
  
  		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';
  
  		if (domain) setCookieData += 'domain=' + domain + ';';
  
  		if (path) setCookieData += 'path=' + path + ';';
  
  		if (expires) {
        dt = new Date();
        ts = dt.getTime();
  
        // 1時間後
        ts_after = ts + (1000 * 60 * 60 * expires);
  
        date = new Date(ts_after);
  			setCookieData += 'expires=' + date.toGMTString() + ';';
  		}
  
  		if (secure && secure === true && location.protocol.match(/https/)) {
  			setCookieData += 'secure';
  		}
  
  		document.cookie = setCookieData;
  
  		return true;
  	},
  
  	/**
  	 * 削除
  	 * @param {string} cookieName 削除するCookieの名前
  	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
  	 */
  	del : function(cookieName) {
  		if (!navigator.cookieEnabled || !cookieName) return false;
  
  		var getCookieDatas = this.get();
  
  		if (getCookieDatas[cookieName]) {
  			var setCookieData = cookieName + '=;',
  			    date          = new Date(0);
  
  			setCookieData += 'expires=' + date.toGMTString() + '';
  
  			document.cookie = setCookieData;
  
  			return true;
  		}
  
  		return false;
  	}
  };
    class Editor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //------- サイドナビ アンカー ---------
      let options = {
        threshold: [0],
        rootMargin: '-49.9%',
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio > 0){
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
          } else {
            $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
          }
        })
      }, options)
  
      const anchorEl = document.querySelectorAll('[id*="anchor"]')
      anchorEl.forEach((e)=>{
        observerEnter.observe(e)
      })
  
      
      $('[id*="anchor"]').each(function() {
        let text = $(this).find('.anchorTitle').text();
        let id = $(this).attr('id');
        if(text) {
          let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
          $('.js-sideNav').append(newElement);
        }
      })
  
      $(".js-sideNav a").click(function() {
        setTimeout(() => {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
        }, 600)
      })
  
  
      //------- 〆サイドナビ アンカー ---------
  
      //------- 画像のheught,widthをrem化 ---------
      $('.text-editor img').each(function(index, el) {
        let width = $(el).attr('width')
        // $(el).attr('width')
        $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
      })
      //------- 画像のheught,widthをrem化 〆 ---------
  
      //------- アコーディオン ---------
      $('.js-editor-accordion .inner').css({'display': 'none'})
  
      $('.js-editor-accordion .trigger').on('click', function() {
        $(this).find('.trigger-icon').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- アコーディオン 〆 ---------
  
      //------- タブ切り替え ---------
      if($(window).innerWidth() >= '769') {
  
        //------- PCの場合 ---------
        $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
        $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
    
        $('.js-tab .trigger .elementor-element').on('click', function() {
          $(this).siblings().removeClass('is-active')
          $(this).addClass('is-active')
          $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
          $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
        })
        //------- PCの場合 〆 ---------
  
      } else {
  
        //------- SPの場合 ---------
        $('.js-tab').each(function() {
          const _el = $(this)
          const trigger_child = _el.find('.trigger-child')
          _el.find('.inner-child').each(function(index) {
            $(this).before(trigger_child[index])
          })
        })
  
        $('<span></span>').appendTo('.trigger-child > div')
  
        $('.inner-child').css({'display': 'none'})
        $('.trigger-child').click(function() {
          $(this).find('span').toggleClass('is-active')
          $(this).next().slideToggle(Number($('html').data('transition')))
        })
        //------- SPの場合 〆 ---------
        
      }
      //------- タブ切り替え 〆 ---------
    }
  }
    class FormConvert {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      //全角から半角
      function replaceZtoH(str){
        str = str.replace(/[！-～]/g, function(s){
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
        return str;
      }
      const el = document.querySelector('.js-convert');
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    }
  }
  
    class Header {
    constructor() {
      if (!document.querySelector('.js-header')) return;
  
      document.addEventListener('alpine:init', () => {
        Alpine.data('headerNav', () => ({
          menuOpen: false,
  
          toggleMenu() {
            this.menuOpen = !this.menuOpen;
            this.syncScrollLock();
          },
  
          closeMenu() {
            if (!this.menuOpen) return;
            this.menuOpen = false;
            this.syncScrollLock();
          },
  
          syncScrollLock() {
            if (this.menuOpen) {
              scrollBanOpen();
            } else {
              scrollBanClose();
            }
          },
        }));
      });
    }
  }
  
    // ------------------------------------------
  // imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
  // 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
  // ------------------------------------------
  class ImgParallax {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      let cls = this.el;
      let para_ele = document.querySelectorAll("." + this.el);
      para_ele.forEach((ele, index)=> {
        let property,scrub;
  
        $(ele).css({
          'object-fit':'cover',
          'object-position':'50% 0%',
          'width':'100%',
          'height':'100%',
        })
  
        property = '50% 100%';
        scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;
  
        ele.classList.add(cls + index);
        gsap.to('.' + cls + index, {
          objectPosition: property,
          scrollTrigger: {
            trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
            start: 'top bottom',
            end: 'bottom top',
            scrub: scrub,
            merker: true,
          }
        })
      })
    }
  }
  
    class InterviewList {
    constructor(selector) {
      this.root = document.querySelector(selector);
      if (!this.root || typeof Swiper === 'undefined') return;
  
      this.sliderEl = this.root.querySelector('.js-interviewListSlider');
      if (!this.sliderEl) return;
  
      this.mq = window.matchMedia('(max-width: 767px)');
      this.originalSliderHtml = this.sliderEl.innerHTML;
      this.slideCount = this.sliderEl.querySelectorAll('.swiper-slide').length;
      if (this.slideCount === 0) return;
  
      this.spaceBetweenDesktop = 40;
      this.spaceBetweenMobile = 24;
      this.resizeTimer = null;
      this.lastWidth = window.innerWidth;
      this.swiper = null;
  
      this.initSwiper();
      this.bindResize();
      this.mq.addEventListener('change', () => {
        this.reinitSwiper();
      });
    }
  
    refreshSlides() {
      this.slides = this.sliderEl.querySelectorAll('.swiper-slide');
    }
  
    isMobile() {
      return this.mq.matches;
    }
  
    getSpaceBetween() {
      return this.isMobile()
        ? this.spaceBetweenMobile
        : this.spaceBetweenDesktop;
    }
  
    getVisibleSlideCount() {
      const slideWidth = this.slides[0].offsetWidth;
      if (!slideWidth) return 1;
  
      const containerWidth = this.sliderEl.offsetWidth || window.innerWidth;
      return Math.max(1, Math.ceil(containerWidth / (slideWidth + this.getSpaceBetween())));
    }
  
    shouldEnableLoop() {
      return this.slideCount > this.getVisibleSlideCount();
    }
  
    getSwiperOptions(enableLoop) {
      return {
        slidesPerView: 'auto',
        centeredSlides: true,
        centeredSlidesBounds: !enableLoop,
        spaceBetween: this.spaceBetweenMobile,
        speed: 600,
        watchSlidesProgress: false,
        roundLengths: true,
        updateOnWindowResize: false,
        observer: false,
        observeParents: false,
        loop: enableLoop,
        loopedSlides: enableLoop ? this.slideCount : undefined,
        allowTouchMove: this.slideCount > 1,
        breakpoints: {
          768: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            spaceBetween: this.spaceBetweenDesktop,
            watchSlidesProgress: true,
            updateOnWindowResize: true,
          },
        },
      };
    }
  
    initSwiper(activeIndex = 0) {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
  
      this.sliderEl.innerHTML = this.originalSliderHtml;
      this.refreshSlides();
  
      const enableLoop = this.shouldEnableLoop();
  
      this.swiper = new Swiper(this.sliderEl, this.getSwiperOptions(enableLoop));
  
      if (enableLoop && activeIndex > 0) {
        this.swiper.slideToLoop(activeIndex, 0, false);
      } else if (!enableLoop && activeIndex > 0) {
        this.swiper.slideTo(activeIndex, 0, false);
      }
    }
  
    reinitSwiper() {
      const activeIndex = this.swiper
        ? (this.swiper.params.loop ? this.swiper.realIndex : this.swiper.activeIndex)
        : 0;
      this.initSwiper(activeIndex);
    }
  
    bindResize() {
      window.addEventListener('resize', () => {
        if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => {
          if (!this.swiper) return;
  
          const width = window.innerWidth;
          if (width === this.lastWidth) return;
  
          const crossedBreakpoint =
            (this.lastWidth < 768 && width >= 768) ||
            (this.lastWidth >= 768 && width < 768);
  
          this.lastWidth = width;
  
          if (crossedBreakpoint) {
            this.reinitSwiper();
            return;
          }
  
          if (this.isMobile()) {
            this.swiper.update();
            return;
          }
  
          this.reinitSwiper();
        }, 200);
      });
    }
  }
  
    class InviewEvent {
    constructor(el, opt){
      this.el = "." + el;
      this.all = this.el + '-all';
      this.eachUp = this.el + '-each';
      this.eachItem = this.el + '-eachItem';
      this.eachItemFast = this.el + '-eachItem-fast';
      this.eachItemDelay = this.el + '-eachItem-delay';
      if($(this.el).length > 0){
        this.event();
      }
    }
    event() {
      let options = {
        threshold: [0, 0.05, 0.1, 1]
      }
      let optionsAll = {
        threshold: [0, 0.9, 1]
      }
      const observerEnter = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.05){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            if(item.classList.contains('js-inview-lottie')){
              this.inviewLottie(item);
            }
            observerEnter.unobserve(item);
          }
        });
      }, options);
      const observerAll = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const item = entry.target;
          if(entry.intersectionRatio >= 0.9){
            item.classList.add('is-inview');
            if(item.classList.contains('js-inview-each')){
              this.inviewEachUp(item);
            }
            observerAll.unobserve(item);
          } else {
            item.classList.remove('is-inview');
          }
        });
      }, optionsAll);
      const inviewItem = document.querySelectorAll(this.el);
      const inviewAllItem = document.querySelectorAll(this.all);
      inviewItem.forEach((e)=>{
        observerEnter.observe(e);
      });
      inviewAllItem.forEach((e)=>{
        observerAll.observe(e);
      });
    }
    inviewEachUp(item){
      $(item).find(this.eachItem).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.2 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemFast).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.1 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
      $(item).find(this.eachItemDelay).each((i,el)=>{
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: (0.5 * i),
          // y: 0,
          // x: 0,
          onComplete: ()=>{
            $(el).addClass('is-inview');
          }
        });
      });
    }
    inviewLottie(item){
      if($(item).hasClass('js-lottie-flow')) {
        lottie.flow();
      }
      if($(item).hasClass('js-lottie-no01')) {
        lottie.no01();
      }
      if($(item).hasClass('js-lottie-no02')) {
        lottie.no02();
      }
      if($(item).hasClass('js-lottie-no03')) {
        lottie.no03();
      }
      if($(item).hasClass('js-lottie-no04')) {
        lottie.no04();
      }
      if($(item).hasClass('js-lottie-no05')) {
        lottie.no05();
      }
      if($(item).hasClass('js-lottie-no06')) {
        lottie.no06();
      }
      if($(item).hasClass('js-lottie-no07')) {
        lottie.no07();
      }
    }
  }
  
    class Modal {
    constructor(el,opt){
      this.el = el;
      this.event();
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $("." + this.el).on('click', function(e) {
        e.preventDefault();
        $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
        scrollBanOpen();
      })
  
      $("." + this.el + "-close").on('click', function() {
        $('.js-modal-container').removeClass('is-active');
        scrollBanClose();
      })
    }
  }
    // -------------------------------------------------
  // スクロール禁止（iOS 実機対応）
  // -------------------------------------------------
  let scrollTop = 0;
  let touchStartY = 0;
  let touchMoveHandler = null;
  let touchStartHandler = null;
  let scrollHandler = null;
  
  const SCROLLABLE_SELECTOR = '.c-header__drawer-scroll, .c-modal, .js-modal-container';
  
  function getScrollTop() {
    return window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
  }
  
  function getScrollableTarget(target) {
    return target.closest(SCROLLABLE_SELECTOR);
  }
  
  function canScrollElement(el, deltaY) {
    if (!el || el.scrollHeight <= el.clientHeight) return false;
  
    const { scrollTop, scrollHeight, clientHeight } = el;
    const isAtTop = scrollTop <= 0;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
  
    if (deltaY > 0 && isAtTop) return false;
    if (deltaY < 0 && isAtBottom) return false;
  
    return true;
  }
  
  function onTouchStart(e) {
    touchStartY = e.touches[0].clientY;
  }
  
  function onTouchMove(e) {
    const currentY = e.touches[0].clientY;
    const deltaY = currentY - touchStartY;
    const scrollable = getScrollableTarget(e.target);
  
    if (canScrollElement(scrollable, deltaY)) return;
  
    e.preventDefault();
  }
  
  function onScrollLock() {
    window.scrollTo(0, scrollTop);
  }
  
  function scrollBanOpen() {
    const html = document.documentElement;
    const body = document.body;
    if (html.classList.contains('is-hidden')) return;
  
    scrollTop = getScrollTop();
  
    body.style.position = 'fixed';
    body.style.top = `${scrollTop * -1}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    body.style.touchAction = 'none';
  
    html.classList.add('is-hidden');
    html.style.overflow = 'hidden';
    $('html').css({ 'scroll-behavior': 'auto' });
  
    touchStartHandler = onTouchStart;
    touchMoveHandler = onTouchMove;
    scrollHandler = onScrollLock;
  
    document.addEventListener('touchstart', touchStartHandler, { passive: true });
    document.addEventListener('touchmove', touchMoveHandler, { passive: false });
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }
  
  function scrollBanClose() {
    const html = document.documentElement;
    const body = document.body;
    if (!html.classList.contains('is-hidden')) return;
  
    if (touchStartHandler) {
      document.removeEventListener('touchstart', touchStartHandler);
      touchStartHandler = null;
    }
  
    if (touchMoveHandler) {
      document.removeEventListener('touchmove', touchMoveHandler);
      touchMoveHandler = null;
    }
  
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
  
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    body.style.touchAction = '';
  
    html.classList.remove('is-hidden');
    html.style.overflow = '';
    html.style.scrollBehavior = 'auto';
    $('html').css({ 'scroll-behavior': 'auto' });
  
    window.scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = scrollTop;
    document.body.scrollTop = scrollTop;
  }
  
  function scrollBan() {
    if (document.documentElement.classList.contains('is-hidden')) {
      scrollBanClose();
    } else {
      scrollBanOpen();
    }
  }
  
  window.scrollBanOpen = scrollBanOpen;
  window.scrollBanClose = scrollBanClose;
  window.scrollBan = scrollBan;
  
    class TopElementor {
    constructor(el,opt){
      this.el = el;
      if($("." + this.el).length > 0){
        this.event();
      }
    }
    event(){
      $('.js-elementor-drawer-trigger').on('click', function(){
        $('html').toggleClass('is-elementor-drawer-open');
        scrollBan();
      });
  
      let scrollTimer;
      $(window).on('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          if($(window).scrollTop() > 100) {
            $('html').addClass('is-scroll');
          } else {
            $('html').removeClass('is-scroll');
          }
        }, 100);
      });
  
    }
  }
  
    class TopInterview {
    constructor(selector) {
      this.root = document.querySelector(selector);
      if (!this.root || typeof Swiper === 'undefined') return;
  
      this.sliderEl = this.root.querySelector('.js-topInterviewSlider');
      if (!this.sliderEl) return;
  
      this.mq = window.matchMedia('(max-width: 767px)');
      this.decoDelay = 300;
      this.decoTimer = null;
      this.resizeTimer = null;
      this.panelLink = this.root.querySelector('.js-topInterviewLink');
      this.nextEl = this.root.querySelector('.js-topInterviewNext');
      this.prevEl = this.root.querySelector('.js-topInterviewPrev');
      this.paginationEl = this.root.querySelector('.js-topInterviewPagination');
      this.slideCount = parseInt(this.root.dataset.slideCount, 10) || 5;
      this.spaceBetweenMobile = 24;
      this.originalSliderHtml = this.sliderEl.innerHTML;
      this.swiper = null;
  
      this.initSwiper();
      this.bindResize();
      this.mq.addEventListener('change', () => {
        this.reinitSwiper();
      });
    }
  
    getSwiperOptions() {
      return {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: this.spaceBetweenMobile,
        loop: true,
        loopedSlides: this.slideCount,
        speed: 600,
        autoHeight: false,
        watchSlidesProgress: false,
        roundLengths: true,
        updateOnWindowResize: false,
        observer: false,
        observeParents: false,
        allowTouchMove: true,
        navigation: {
          nextEl: this.nextEl,
          prevEl: this.prevEl,
        },
        pagination: {
          el: this.paginationEl,
          clickable: true,
          renderBullet: (index, className) =>
            `<span class="${className}"></span>`,
        },
        breakpoints: {
          768: {
            centeredSlides: false,
            spaceBetween: 30,
            slidesPerView: 'auto',
            autoHeight: true,
            watchSlidesProgress: true,
            updateOnWindowResize: true,
            allowTouchMove: false,
            simulateTouch: false,
          },
        },
        on: {
          init: () => {
            this.onSlideReady();
          },
          slideChangeTransitionStart: () => {
            if (!this.isMobile()) this.clearDeco();
          },
          slideChangeTransitionEnd: () => {
            this.onSlideReady();
          },
        },
      };
    }
  
    initSwiper(activeIndex = 0) {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
  
      this.sliderEl.innerHTML = this.originalSliderHtml;
      this.swiper = new Swiper(this.sliderEl, this.getSwiperOptions());
  
      if (activeIndex > 0) {
        this.swiper.slideToLoop(activeIndex, 0, false);
      }
  
      if (this.isMobile()) {
        this.setMobileDeco();
      }
    }
  
    reinitSwiper() {
      const activeIndex = this.swiper ? this.swiper.realIndex : 0;
      if (!this.isMobile()) {
        this.clearDeco();
      }
      this.initSwiper(activeIndex);
    }
  
    bindResize() {
      this.lastWidth = window.innerWidth;
  
      window.addEventListener('resize', () => {
        if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => {
          if (!this.swiper) return;
  
          const width = window.innerWidth;
          if (width === this.lastWidth) return;
  
          const crossedBreakpoint =
            (this.lastWidth < 768 && width >= 768) ||
            (this.lastWidth >= 768 && width < 768);
  
          this.lastWidth = width;
  
          if (crossedBreakpoint) {
            this.reinitSwiper();
            return;
          }
  
          if (this.isMobile()) {
            this.swiper.update();
            return;
          }
  
          this.reinitSwiper();
        }, 200);
      });
    }
  
    isMobile() {
      return this.mq.matches;
    }
  
    onSlideReady() {
      const activeSlide = this.sliderEl.querySelector('.swiper-slide-active');
      if (!activeSlide) return;
  
      this.updatePanel(activeSlide);
  
      if (this.isMobile()) return;
  
      this.clearDeco();
      this.showDeco();
    }
  
    setMobileDeco() {
      if (this.decoTimer) {
        window.clearTimeout(this.decoTimer);
        this.decoTimer = null;
      }
  
      this.root.querySelectorAll('.p-top__interview-visual').forEach((el) => {
        el.classList.add('is-deco-visible');
      });
    }
  
    showDeco() {
      const activeSlide = this.sliderEl.querySelector('.swiper-slide-active');
      if (!activeSlide) return;
  
      this.updatePanel(activeSlide);
  
      const visual = activeSlide.querySelector('.p-top__interview-visual');
      if (!visual) return;
  
      this.decoTimer = window.setTimeout(() => {
        visual.classList.add('is-deco-visible');
      }, this.decoDelay);
    }
  
    clearDeco() {
      if (this.decoTimer) {
        window.clearTimeout(this.decoTimer);
        this.decoTimer = null;
      }
  
      this.root.querySelectorAll('.p-top__interview-visual.is-deco-visible').forEach((el) => {
        el.classList.remove('is-deco-visible');
      });
    }
  
    updatePanel(slide) {
      const { url, label } = slide.dataset;
  
      if (this.panelLink) {
        this.panelLink.href = url || '#';
        if (label) this.panelLink.setAttribute('aria-label', label);
      }
    }
  }
  
    class TopWorks {
    constructor(selector) {
      this.root = document.querySelector(selector);
      if (!this.root) return;
  
      this.mq = window.matchMedia('(max-width: 767px)');
      if (this.mq.matches) return;
  
      this.items = [...this.root.querySelectorAll('.p-top__works-item')];
      this.panels = [...this.root.querySelectorAll('.p-top__works-panel')];
      this.duration = 450;
      this.isAnimating = false;
      this.activeIndex = this.items.findIndex((item) => item.classList.contains('is-active'));
      if (this.activeIndex < 0) this.activeIndex = 0;
  
      this.bind();
    }
  
    bind() {
      const prev = this.root.querySelector('.js-topWorksPrev');
      const next = this.root.querySelector('.js-topWorksNext');
  
      prev?.addEventListener('click', () => this.go(-1));
      next?.addEventListener('click', () => this.go(1));
  
      this.items.forEach((item, index) => {
        const trigger = item.querySelector('.p-top__works-item-btn');
        trigger?.addEventListener('click', () => {
          if (index !== this.activeIndex) this.goTo(index);
        });
      });
    }
  
    go(direction) {
      const length = this.items.length;
      const nextIndex = (this.activeIndex + direction + length) % length;
      this.goTo(nextIndex);
    }
  
    goTo(index) {
      if (this.isAnimating || index === this.activeIndex) return;
  
      this.isAnimating = true;
      const currentItem = this.items[this.activeIndex];
      const nextItem = this.items[index];
      const currentPanel = this.panels[this.activeIndex];
      const nextPanel = this.panels[index];
  
      currentItem.classList.remove('is-active');
      currentItem.classList.add('is-leaving');
      currentPanel.classList.remove('is-active');
  
      nextItem.classList.add('is-active', 'is-entering');
      nextPanel.classList.add('is-active');
  
      void nextItem.offsetWidth;
  
      window.setTimeout(() => {
        currentItem.classList.remove('is-leaving');
        nextItem.classList.remove('is-entering');
        this.activeIndex = index;
        this.isAnimating = false;
      }, this.duration);
    }
  }
  

  // 読み込み・レンダリング完了後にローディングを閉じる（最低表示時間 0.5s）
  const MIN_LOADING_MS = 500;

  const whenWindowLoaded = () => new Promise((resolve) => {
    if (document.readyState === 'complete') {
      resolve();
      return;
    }
    window.addEventListener('load', resolve, { once: true });
  });

  const whenFontsReady = () => {
    if (document.fonts && document.fonts.ready) {
      return document.fonts.ready.catch(() => {});
    }
    return Promise.resolve();
  };

  const whenPainted = () => new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    });
  });

  const hideLoading = () => {
    const remaining = Math.max(0, MIN_LOADING_MS - performance.now());
    setTimeout(() => {
      $('.js-loading').fadeOut();
    }, remaining);
  };

  Promise.all([whenWindowLoaded(), whenFontsReady()])
    .then(whenPainted)
    .then(hideLoading);

  (() => {

    let imgParallax = new ImgParallax('js-parallax');
    let inviewEvent = new InviewEvent('js-inview');
    
    // ------------------------------
    // トップページ用
    // ------------------------------
    let top = new Top('p-top');
    
    // ------------------------------
    // ページビルダー用
    // ------------------------------
    let header = new Header();
    let topElementor = new TopElementor('js-topElementor');
    let modal = new Modal('js-modal');
    let accordion = new Accordion('js-accordion');
    let editor = new Editor('c-content');

    if (document.querySelector('.js-interviewList')) {
      new InterviewList('.js-interviewList');
    }

  })();

  //DOMContentLoaded
  $(() => {
  });

  //images resources loaded
  $(window).on('load', () => {

    $(window).trigger('loading');
  });

  //after loading animation
  $(window).on('loading', () => {
  });
})(jQuery);